import { useQuery } from '@tanstack/react-query';
import { getCoreKnowledge } from '../Redux/util/Apis/knowledge';

export const groupKnowledgeByCategory = knowledgeItems => {
  if (!knowledgeItems || !Array.isArray(knowledgeItems)) {
    return {};
  }

  const grouped = {};

  knowledgeItems.forEach(item => {
    const category = item.category || 'General';

    if (!grouped[category]) {
      grouped[category] = [];
    }

    grouped[category].push({
      id: item.id,
      questionId: item.question_id,
      question: item.question,
      answer: item.answer,
      isOfficial: item.is_official,
      source: item.source,
      communityId: item.community_id
    });
  });

  return grouped;
};

export const useCoreKnowledge = (options = {}) => {
  const { clientId, communityId } = options;

  return useQuery({
    queryKey: ['coreKnowledge', clientId, communityId],
    queryFn: async () => {
      const result = await getCoreKnowledge(clientId, communityId);

      if (result?.error) {
        throw new Error(result.message || 'Failed to fetch core knowledge');
      }

      // getCoreKnowledge already returns response.data, so result is the array directly
      const data = Array.isArray(result) ? result : [];
      return groupKnowledgeByCategory(data);
    },
    enabled: !!clientId
  });
};

export default useCoreKnowledge;
